import { throttle } from 'lodash-es'

/**
 * Add throttle wrapper to prevent modal events being fired multiple times
 */
const THROTTLE_WAIT_MS = 500
export function throttleWrapper(fn) {
  return throttle(fn, THROTTLE_WAIT_MS, { trailing: false })
}
